import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';
import Select from 'react-select';

declare global {
  interface Window { AjaxZip3: any; }
}

interface institution {
  m_company_id:         number,
  gcs_institution_code: string,
  gcs_note:             string,
  institution_name:     string,
  institution_kana:     string,
  zip_cd:               string,
  address1:             string,
  address2:             string,
  address3:             string,
  tel:                  string,
  fax:                  string,
  homepage_url:         string,
  institution_key:      string,
  videocall_enable_flg: number,
  interview_enable_flg: number,
  open_hour_interspace: number,
  examination_time:     number,
  reserve_note_display_flg: number,
  reserve_note:         string,
  web_reserve_enable_flg: number,
  that_day_reserve_available_kbn: number,
  is_prescription_required: boolean,
  is_insurance_card_required: boolean,
  reserve_login_title:   string,
  is_onshikaku:          boolean,
  mi_code:               string,
  line_add_button:       string,
  line_add_qr:           string,
  is_interview_unification: boolean,
  interview_message:     string
}

interface confirmation {
  privacy_policy_display_flg: number,
  privacy_policy:             string,
  agreement_display_flg:      number,
  agreement:                  string,
}

interface institutionHour {
  am_from: Array<string>,
  am_to: Array<string>,
  am_reserve_max_cnt: Array<string>,
  pm_from: Array<string>,
  pm_to: Array<string>,
  pm_reserve_max_cnt: Array<string>,
  m_institution_id: number
}

interface radio {
  label: string
  value: string
}

interface numberRadio {
  label: string
  value: number
}

interface booleanRadio {
  label: string
  value: boolean
}

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  // ユーザー
  let institutionInit = {
    m_company_id:         props.m_companies[0].id,
    gcs_institution_code: null,
    gcs_note:             null,
    institution_name:     null,
    institution_kana:     null,
    zip_cd:               null,
    address1:             null,
    address2:             null,
    address3:             null,
    tel:                  null,
    fax:                  null,
    homepage_url:         null,
    institution_key:      null,
    videocall_enable_flg: 0,
    interview_enable_flg: 0,
    open_hour_interspace: 30,
    examination_time:     60,
    reserve_note_display_flg: 0,
    reserve_note:           props.reserve_note,
    web_reserve_enable_flg: 0,
    that_day_reserve_available_kbn: 0,
    is_prescription_required: false,
    is_insurance_card_required: false,
    reserve_login_title:     null,
    is_onshikaku:            false,
    mi_code:                 null,
    line_add_button:         null,
    line_add_qr:             null,
    is_interview_unification: false,
  } as institution

  let confirmationInit = {
    privacy_policy_display_flg: 0,
    privacy_policy:             props.privacy_policy,
    agreement_display_flg:      0,
    agreement:                  props.agreement
  } as confirmation

  let institutionHourInit = {
    am_from: ["", "", "", "", "", "", ""],
    am_to: ["", "", "", "", "", "", ""],
    am_reserve_max_cnt: ["", "", "", "", "", "", ""],
    pm_from: ["", "", "", "", "", "", ""],
    pm_to: ["", "", "", "", "", "", ""],
    pm_reserve_max_cnt: ["", "", "", "", "", "", ""],
    m_institution_id: props.m_institution_id
  } as institutionHour


  // メール通知区分
  let flgKbns: numberRadio[] = [
    { label: "有効", value: 1},
    { label: "無効", value: 0},
  ]

  let confirmationKbns: numberRadio[] = [
    { label: "患者様側画面（同意取得画面）に表示する", value: 1},
    { label: "表示しない", value: 0},
  ]

   // メール通知区分
  let requiredKbns: booleanRadio[] = [
    { label: "有効", value: true},
    { label: "無効", value: false},
  ]

  let openHourInterspaceKbns: numberRadio[] = [
    { label: "10分", value: 10},
    { label: "15分", value: 15},
    { label: "20分", value: 20},
    { label: "30分", value: 30},
  ]

  let examinationTimeKbns: numberRadio[] = [
    { label: "15分", value: 15},
    { label: "20分", value: 20},
    { label: "30分", value: 30},
    { label: "45分", value: 45},
    { label: "60分", value: 60},
    { label: "90分", value: 90},
    { label: "120分", value: 120},
  ]

  let thatDayReserveAvailableKbns: numberRadio[] = [
    { label: "制限なし", value: 0},
    { label: "３０分前", value: 1},
    { label: "１時間前", value: 2},
    { label: "２時間前", value: 3},
    { label: "当日予約不可", value: 99},
  ]

  let weeks: numberRadio[] = [
    { label: "日曜日", value: 0},
    { label: "月曜日", value: 1},
    { label: "火曜日", value: 2},
    { label: "水曜日", value: 3},
    { label: "木曜日", value: 4},
    { label: "金曜日", value: 5},
    { label: "土曜日", value: 6},
  ]

  

  // テンプレート内容
  const [institution, setInstitution] = useState<institution>(institutionInit);
  const [confirmation, setConfirmation] = useState<confirmation>(confirmationInit);
  const [institutionHour, setInstitutionHour] = useState<institutionHour>(institutionHourInit);
  const [paymentEnabled, setPaymentEnabled] = useState<Boolean>(false);

  const [errorMessage, setErrorMessage] = useState("");

  // ロード系
  const [isLoading, setIsLoading]  = useState<Boolean>(false);

  // 初回ロード
  useEffect(() =>{
    if (props.action_name == "edit"){
      setIsLoading(true);
      axios.get(
        `/api/internal/institutions/edit?id=${props.m_institution_id}`, {})
      .then(function (response) {
        setInstitution(response.data.m_institution);
        setConfirmation(response.data.m_confirmation);
        setInstitutionHour(response.data.m_institution_hours);
        setPaymentEnabled(response.data.institution_payment_enabled);
      }).catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }).finally(() => {
        setIsLoading(false);
      });
    }
  },[]);

  // // 登録・更新処理
  function submitInstitution() {
    setIsLoading(true);
    if (props.action_name == "edit"){
      axios.post(
        '/api/internal/institutions/update', {m_institution: institution, m_institution_hours: institutionHour, m_confirmation: confirmation})
      .then(function (response) {
        nextPage();
      }).catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }).finally(() => {
        setIsLoading(false);
      });
    }else{
      axios.post(
        '/api/internal/institutions/create', {m_institution: institution, m_institution_hours: institutionHour, m_confirmation: confirmation})
      .then(function (response) {
        nextPage();
      }).catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }

  function nextPage(){
   if(props.current_m_user.gcs_user){
    location.href = (`/institutions/index`);
   }else{
    location.reload();
   }
  }

  // 住所取得成功時
  window.AjaxZip3.onSuccess = function() {
    const address1 = document.getElementById('m_institution_address1') as HTMLInputElement;
    const address2 = document.getElementById('m_institution_address2') as HTMLInputElement;
    const address3 = document.getElementById('m_institution_address3') as HTMLInputElement;

    setInstitution({...institution, address1: address1.value, address2: address2.value, address3: address3.value});
  }

  function stringBooleanConversion(value){
   return value == "true" ? true : false
  }

  const onChangeCompanyId = (option) => {
    setInstitution({...institution, m_company_id: Number(option["value"])})
  }

  // ラジオボタン更新
  const changeVideocallEnableFlg         = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, videocall_enable_flg: Number(event.target.value)});
  const changeInterviewEnableFlg         = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, interview_enable_flg: Number(event.target.value)});
  const changeOpenHourInterspace         = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, open_hour_interspace: Number(event.target.value)});
  const changeExaminationTime            = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, examination_time: Number(event.target.value)});
  const changePrivacyPolicyDisplayFlg    = (event: React.ChangeEvent<HTMLInputElement>) => setConfirmation({...confirmation, privacy_policy_display_flg: Number(event.target.value)});
  const changeAgreementDisplayFlg        = (event: React.ChangeEvent<HTMLInputElement>) => setConfirmation({...confirmation, agreement_display_flg: Number(event.target.value)});
  const changeReserveNoteDisplayFlg      = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, reserve_note_display_flg: Number(event.target.value)});
  const changeWebReserveEnableFlg        = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, web_reserve_enable_flg: Number(event.target.value)});
  const changeThatDayReserveAvailableKbn = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, that_day_reserve_available_kbn: Number(event.target.value)});
  const changeIsPrescriptionRequired     = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, is_prescription_required: stringBooleanConversion(event.target.value)});
  const changeIsInsuranceCardRequired    = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, is_insurance_card_required: stringBooleanConversion(event.target.value)});
  const changeIsOnshikaku                = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, is_onshikaku: stringBooleanConversion(event.target.value)});
  const changeIsInterviewUnification     = (event: React.ChangeEvent<HTMLInputElement>) => setInstitution({...institution, is_interview_unification: stringBooleanConversion(event.target.value)});

  return(
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          { errorMessage }
        </div>
      }
      { props.current_m_user.gcs_user && 
        <>

          <div className="form-group">
            <label htmlFor="m_institution_m_company_id">企業名</label><span className="label label-danger ml5">必須</span>
            <Select
              id="m_institution_m_company_id"
              isDisabled={!props.current_m_user.gcs_editor_and_above}
              onChange={onChangeCompanyId}
              options={props.m_companies}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="企業名を選択してください。"
              value={props.m_companies.find(m_company => m_company.value === institution.m_company_id)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="m_institution_gcs_institution_code">店舗コード</label><span className="label label-danger ml5">必須</span>
            <input disabled={!props.current_m_user.gcs_editor_and_above} className="form-control" placeholder="店舗コード" type="text" id="m_institution_gcs_institution_code" value={institution.gcs_institution_code} defaultValue={institution.gcs_institution_code} onChange={(e) => setInstitution({...institution, gcs_institution_code: e.target.value})}/>
          </div>

          <div className="form-group">
            <label htmlFor="m_institution_gcs_note">GCS用備考欄（GCS用管理画面のみ使用）</label>
            <textarea disabled={!props.current_m_user.gcs_editor_and_above} className="form-control" rows={15} placeholder="GCS用備考欄（GCS用管理画面のみ使用）" id="m_institution_gcs_note" value={institution.gcs_note}  defaultValue={institution.gcs_note} onChange={(e) => setInstitution({...institution, gcs_note: e.target.value})}/>
          </div>
        </>
      }


      <div className="form-group">
        <label htmlFor="m_institution_institution_name">店舗名</label><span className="label label-danger ml5">必須</span>
        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="店舗名" type="text" id="m_institution_institution_name" value={institution.institution_name} defaultValue={institution.institution_name} onChange={(e) => setInstitution({...institution, institution_name: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_institution_institution_kana">店舗名(カナ)</label>
        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="テンポメイ" type="text" id="m_institution_institution_kana" value={institution.institution_kana} defaultValue={institution.institution_kana} onChange={(e) => setInstitution({...institution, institution_kana: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_institution_zip_cd">郵便番号</label>
        <div className="form-inline">
          <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control mr10" name="zip_cd" placeholder="999-9999" type="text" id="m_institution_zip_cd" value={institution.zip_cd} defaultValue={institution.zip_cd} onChange={(e) => setInstitution({...institution, zip_cd: e.target.value})}/>
          <button disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="btn btn-info" name="button" type="button" onClick={() => window.AjaxZip3.zip2addr('zip_cd','','m_institution_address1','m_institution_address2')}>〒 → 住所</button>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="m_institution_zip_cd">住所</label>
        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="東京都" type="text" name="m_institution_address1" id="m_institution_address1" value={institution.address1} defaultValue={institution.address1} onChange={(e) => setInstitution({...institution, address1: e.target.value})}/>
        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="中央区八丁堀" type="text" name="m_institution_address2" id="m_institution_address2" value={institution.address2} defaultValue={institution.address2} onChange={(e) => setInstitution({...institution, address2: e.target.value})}/>
        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="三丁目10番1号" type="text" name="m_institution_address3" id="m_institution_address3" value={institution.address3} defaultValue={institution.address3} onChange={(e) => setInstitution({...institution, address3: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_institution_tel">電話番号</label>
        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="03-0000-0000" type="text" id="m_institution_tel" value={institution.tel} defaultValue={institution.tel} onChange={(e) => setInstitution({...institution, tel: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_institution_fax">fax番号</label>
        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="03-0000-1111" type="text" id="m_institution_fax" value={institution.fax} defaultValue={institution.fax} onChange={(e) => setInstitution({...institution, fax: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_institution_homepage_url">ホームページURL</label>
        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="ホームページのURL" type="text" id="m_institution_homepage_url" value={institution.homepage_url} defaultValue={institution.homepage_url} onChange={(e) => setInstitution({...institution, homepage_url: e.target.value})}/>
      </div>
      { props.current_m_user.gcs_user && 
      <>
        <div className="form-group">
          <label htmlFor="m_institution_institution_key">店舗専用キー情報</label><span className="label label-danger ml5">必須</span>
          <input disabled={!props.current_m_user.gcs_editor_and_above} className="form-control" placeholder="固有のキー情報" type="text" id="m_institution_institution_key" value={institution.institution_key} defaultValue={institution.institution_key} onChange={(e) => setInstitution({...institution, institution_key: e.target.value})}/>
        </div>

      
        <div className="form-group">
          <label>ご利用システムの設定</label>
          <br/>
          <div className="radio-inline">
            <label>Videocall</label>
            { flgKbns.map((flgKbn) =>{
              return(
                <>
                  <input disabled={!props.current_m_user.gcs_editor_and_above} className={ props.current_m_user.gcs_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={flgKbn.value === institution.videocall_enable_flg} type="radio" value={flgKbn.value} name="m_institution_videocall_enable_flg" id={`m_institution_videocall_enable_flg_${flgKbn.value}`} onChange={changeVideocallEnableFlg}/>
                  <label className="m10" htmlFor={`m_institution_videocall_enable_flg_${flgKbn.value}`}>{flgKbn.label}</label>
                </>
              )
            })}
          </div>
          <br/>
          <div className="radio-inline">
            <label>先確認</label>
            { flgKbns.map((flgKbn) =>{
              return(
                <>
                  <input disabled={!props.current_m_user.gcs_editor_and_above} className={ props.current_m_user.gcs_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={flgKbn.value === institution.interview_enable_flg} type="radio" value={flgKbn.value} name="m_institution_interview_enable_flg" id={`m_institution_interview_enable_flg_${flgKbn.value}`} onChange={changeInterviewEnableFlg}/>
                  <label className="m10" htmlFor={`m_institution_interview_enable_flg_${flgKbn.value}`}>{flgKbn.label}</label>
                </>
            )})}
          </div>
        </div>
      </>
      }



      { institution.videocall_enable_flg == 1 && (
        <>
          {
            props.action_name == "edit" && (
              <div className="form-group">
                <label htmlFor="m_institution_gcs_institution_code">決済利用可能状況　</label>
                  { paymentEnabled ? <span className="label label-success">利用可能</span> : <span className="label label-danger">利用不可</span> }
              </div>
            )
          }

         <div className="form-group">
          <label>予約時間間隔(分)</label>
           <div className="radio-inline">
             { openHourInterspaceKbns.map((openHourInterspaceKbn) =>{
               return(
                 <>
                   <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"} checked={openHourInterspaceKbn.value === institution.open_hour_interspace} type="radio" value={openHourInterspaceKbn.value} name="m_institution_open_hour_interspace" id={`m_institution_open_hour_interspace_${openHourInterspaceKbn.value}`} onChange={changeOpenHourInterspace}/>
                   <label className="m10" htmlFor={`m_institution_open_hour_interspace_${openHourInterspaceKbn.value}`}>{openHourInterspaceKbn.label}</label>
                 </>
             )})}
           </div>
       </div>
 
       <div className="form-group">
         <label>予約時に確保する時間の初期値(分)</label>
         <div className="radio-inline">
           { examinationTimeKbns.map((examinationTimeKbn) =>{
             return(
               <>
                 <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={examinationTimeKbn.value === institution.examination_time} type="radio" value={examinationTimeKbn.value} name="m_institution_examination_time" id={`m_institution_examination_time_${examinationTimeKbn.value}`} onChange={changeExaminationTime}/>
                 <label className="m10" htmlFor={`m_institution_examination_time_${examinationTimeKbn.value}`}>{examinationTimeKbn.label}</label>
               </>
           )})}
         </div>
       </div>
 
       <div className="form-group">
         <label>プライバシーポリシーについて</label>
         <div className="radio-inline">
           { confirmationKbns.map((confirmationKbn) =>{
             return(
               <>
                 <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={confirmationKbn.value === confirmation.privacy_policy_display_flg} type="radio" value={confirmationKbn.value} name="m_confirmation_privacy_policy_display_flg" id={`m_confirmation_privacy_policy_display_flg_${confirmationKbn.value}`} onChange={changePrivacyPolicyDisplayFlg}/>
                 <label className="m10" htmlFor={`m_confirmation_privacy_policy_display_flg_${confirmationKbn.value}`}>{confirmationKbn.label}</label>
               </>
           )})}
         </div>
         <textarea disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" rows={15} placeholder="プライバシーポリシーを貼り付けてください" id="m_confirmation_privacy_policy" value={confirmation.privacy_policy}  defaultValue={confirmation.privacy_policy} onChange={(e) => setConfirmation({...confirmation, privacy_policy: e.target.value})}/>
       </div>
 
      { props.is_clinic ? 
        // クリニック向け
        <div className="form-group">
          <label>オンライン診療に関する同意内容について</label>
          <div className="radio-inline">
            { confirmationKbns.map((confirmationKbn) =>{
              return(
                <>
                  <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={confirmationKbn.value === confirmation.agreement_display_flg} type="radio" value={confirmationKbn.value} name="m_confirmation_agreement_display_flg" id={`m_confirmation_agreement_display_flg_${confirmationKbn.value}`} onChange={changeAgreementDisplayFlg}/>
                  <label className="m10" htmlFor={`m_confirmation_agreement_display_flg_${confirmationKbn.value}`}>{confirmationKbn.label}</label>
                </>
            )})}
          </div>
          <br/>
          <small>一度も同意を確認できていない患者様のビデオ通話開始画面に同意取得画面が表示されます。一度同意を得た場合も「プライバシーポリシー」もしくは「オンライン診療に関する同意内容について」が更新された場合は再度確認を求めます。</small>
          <textarea disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" rows={15} placeholder="オンライン診療に関する同意内容を貼り付けてください" id="m_confirmation_agreement" value={confirmation.agreement}  defaultValue={confirmation.agreement} onChange={(e) => setConfirmation({...confirmation, agreement: e.target.value})}/>
        </div>
        :
        <div className="form-group">
          <label>オンライン服薬指導に関する同意内容について</label>
          <div className="radio-inline">
            { confirmationKbns.map((confirmationKbn) =>{
              return(
                <>
                  <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={confirmationKbn.value === confirmation.agreement_display_flg} type="radio" value={confirmationKbn.value} name="m_confirmation_agreement_display_flg" id={`m_confirmation_agreement_display_flg_${confirmationKbn.value}`} onChange={changeAgreementDisplayFlg}/>
                  <label className="m10" htmlFor={`m_confirmation_agreement_display_flg_${confirmationKbn.value}`}>{confirmationKbn.label}</label>
                </>
            )})}
          </div>
          <br/>
          <small>一度も同意を確認できていない患者様のビデオ通話開始画面に同意取得画面が表示されます。一度同意を得た場合も「プライバシーポリシー」もしくは「オンライン服薬指導に関する同意内容について」が更新された場合は再度確認を求めます。</small>
          <textarea disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" rows={15} placeholder="オンライン服薬指導に関する同意内容を貼り付けてください" id="m_confirmation_agreement" value={confirmation.agreement}  defaultValue={confirmation.agreement} onChange={(e) => setConfirmation({...confirmation, agreement: e.target.value})}/>
        </div>
      }
 
       <div className="form-group">
         <label>注意事項・ご用意頂くもの</label>
         <div className="radio-inline">
           { confirmationKbns.map((confirmationKbn) =>{
             return(
               <>
                 <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={confirmationKbn.value === institution.reserve_note_display_flg} type="radio" value={confirmationKbn.value} name="m_institution_reserve_note_display_flg" id={`m_institution_reserve_note_display_flg_${confirmationKbn.value}`} onChange={changeReserveNoteDisplayFlg}/>
                 <label className="m10" htmlFor={`m_institution_reserve_note_display_flg_${confirmationKbn.value}`}>{confirmationKbn.label}</label>
               </>
           )})}
         </div>
         <textarea disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" rows={15} placeholder="注意事項・ご用意頂くもの内容を貼り付けてください" id="m_institution_reserve_note" value={institution.reserve_note}  defaultValue={institution.reserve_note} onChange={(e) => setInstitution({...institution, reserve_note: e.target.value})}/>
       </div>
 
       <label className="controle-label">休み時間設定</label><span className="label label-danger ml5">必須</span>
       <p>空白のところは閉店となります。</p>
       <div className="table-responsive">
         <table id="notice_table" className="table table-bordered table-hover pointer">
           <thead>
             <tr className="success">
               <th scope="col" className="text-center col-lg-2 col-xs-2">曜日</th>
               <th scope="col" className="text-center col-lg-1 col-xs-1"></th>
               <th scope="col" className="text-center col-lg-3 col-xs-3">開始時間</th>
               <th scope="col" className="text-center col-lg-3 col-xs-3">終了時間</th>
               <th scope="col" className="text-center col-lg-3 col-xs-3">予約可能人数</th>
             </tr>
           </thead>
           <tbody>
             {
               weeks.map((week) =>{
                 return(
                   <>
                    <tr>
                      <td className="text-center" rowSpan={2}>{week.label}</td>
                      <td className="text-center">午前</td>
                      <td className="pos_relative">
                        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} type="text" name={`m_institution_hour[am_from][${week.value}]`} id={`m_institution_hour_am_from_${week.value}`} data-date-format="HH:mm" className="form-control timepicker" placeholder="hh:mm" value={institutionHour.am_from[week.value]} defaultValue={institutionHour.am_from[week.value]} onChange={(e) => setInstitutionHour({...institutionHour, am_from: institutionHour.am_from.map((value, index) => (index === week.value ? e.target.value : value))})}/>
                      </td>
                      <td className="pos_relative">
                        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} type="text" name={`m_institution_hour[am_to][${week.value}]`} id={`m_institution_hour_am_to_${week.value}`} data-date-format="HH:mm" className="form-control timepicker" placeholder="hh:mm" value={institutionHour.am_to[week.value]} defaultValue={institutionHour.am_to[week.value]} onChange={(e) => setInstitutionHour({...institutionHour, am_to: institutionHour.am_to.map((value, index) => (index === week.value ? e.target.value : value))})}/>
                      </td>
                      <td>
                        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} type="number" name={`m_institution_hour[am_reserve_max_cnt][${week.value}]`} id={`m_institution_hour_am_reserve_max_cnt_${week.value}`} className="form-control" value={institutionHour.am_reserve_max_cnt[week.value]} defaultValue={institutionHour.am_reserve_max_cnt[week.value]} onChange={(e) => setInstitutionHour({...institutionHour, am_reserve_max_cnt: institutionHour.am_reserve_max_cnt.map((value, index) => (index === week.value ? e.target.value : value))})}/>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-center">午後</td>
                      <td className="pos_relative">
                        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} type="text" name={`m_institution_hour[pm_from][${week.value}]`} id={`m_institution_hour_pm_from_${week.value}`} data-date-format="HH:mm" className="form-control timepicker" placeholder="hh:mm"  value={institutionHour.pm_from[week.value]} defaultValue={institutionHour.pm_from[week.value]} onChange={(e) => setInstitutionHour({...institutionHour, pm_from: institutionHour.pm_from.map((value, index) => (index === week.value ? e.target.value : value))})}/>
                      </td>
                      <td className="pos_relative">
                        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} type="text" name={`m_institution_hour[pm_to][${week.value}]`} id={`m_institution_hour_pm_to_${week.value}`} data-date-format="HH:mm" className="form-control timepicker" placeholder="hh:mm"  value={institutionHour.pm_to[week.value]} defaultValue={institutionHour.pm_to[week.value]} onChange={(e) => setInstitutionHour({...institutionHour, pm_to: institutionHour.pm_to.map((value, index) => (index === week.value ? e.target.value : value))})}/>
                      </td>
                      <td>
                        <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} type="number" name={`m_institution_hour[pm_reserve_max_cnt][${week.value}]`} id={`m_institution_hour_pm_reserve_max_cnt_${week.value}`} className="form-control"  value={institutionHour.pm_reserve_max_cnt[week.value]} defaultValue={institutionHour.pm_reserve_max_cnt[week.value]} onChange={(e) => setInstitutionHour({...institutionHour, pm_reserve_max_cnt: institutionHour.pm_reserve_max_cnt.map((value, index) => (index === week.value ? e.target.value : value))})}/>
                      </td>
                    </tr>
                  </>
                 )
               })
             }

          </tbody>
         </table>
       </div>
 
       <div className="form-group">
         <label htmlFor="m_institution_web_reserve_enable_flg">患者向けWeb予約画面</label>
         <br/>
         <div className="radio-inline">
           <label>Web予約</label>
           { flgKbns.map((flgKbn) =>{
             return(
               <>
                 <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={flgKbn.value === institution.web_reserve_enable_flg} type="radio" value={flgKbn.value} name="m_institution_web_reserve_enable_flg" id={`m_institution_web_reserve_enable_flg_${flgKbn.value}`} onChange={changeWebReserveEnableFlg}/>
                 <label className="m10" htmlFor={`m_institution_web_reserve_enable_flg_${flgKbn.value}`}>{flgKbn.label}</label>
               </>
           )})}
         </div>
         <br/>
         {
           <>
            <div className="radio-inline">
              <label>URL　</label>
              {
                props.action_name == "edit" && <a className="text-primary under" href={`https://${props.host_name}/${institution.institution_key}/reserves/new`}>{`https://${props.host_name}/${institution.institution_key}/reserves/new`}</a>
              }
              
            </div>
            <br/>
           </>
         }

         <div className="radio-inline">
           <label>当日Web予約可能時間</label>
           { thatDayReserveAvailableKbns.map((thatDayReserveAvailableKbn) =>{
             return(
               <>
                 <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={thatDayReserveAvailableKbn.value === institution.that_day_reserve_available_kbn} type="radio" value={thatDayReserveAvailableKbn.value} name="m_institution_that_day_reserve_available_kbn" id={`m_institution_that_day_reserve_available_kbn_${thatDayReserveAvailableKbn.value}`} onChange={changeThatDayReserveAvailableKbn}/>
                 <label className="m10" htmlFor={`m_institution_that_day_reserve_available_kbn_${thatDayReserveAvailableKbn.value}`}>{thatDayReserveAvailableKbn.label}</label>
               </>
           )})}
         </div>
         <br/>
         { !props.is_clinic && (
            <>
            <div className="radio-inline">
              <label>処方箋の添付を必須にする</label>
              { requiredKbns.map((requiredKbn) =>{
                return(
                <>
                  <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={requiredKbn.value === institution.is_prescription_required} type="radio" value={`${requiredKbn.value}`} name="m_institution_is_prescription_required" id={`m_institution_is_prescription_required_${requiredKbn.value}`} onChange={changeIsPrescriptionRequired}/>
                  <label className="m10" htmlFor={`m_institution_is_prescription_required_${requiredKbn.value}`}>{requiredKbn.label}</label>
                </>
              )})}
            </div>
            <br/>
          </>
          )}

         <div className="radio-inline">
           <label>{props.is_clinic ? "資格確認証" : "保険証"}の添付を必須にする</label>
           { requiredKbns.map((requiredKbn) =>{
             return(
               <>
                 <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={requiredKbn.value === institution.is_insurance_card_required} type="radio" value={`${requiredKbn.value}`} name="m_institution_is_insurance_card_required" id={`m_institution_is_insurance_card_required_${requiredKbn.value}`} onChange={changeIsInsuranceCardRequired}/>
                 <label className="m10" htmlFor={`m_institution_is_insurance_card_required_${requiredKbn.value}`}>{requiredKbn.label}</label>
               </>
           )})}
         </div>
         <br/>
         <div className="radio-inline w100p">
           <label htmlFor="m_institution_reserve_login_title">ログイン画面のタイトル</label>
           <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" placeholder="GCSログイン画面" type="text" id="m_institution_reserve_login_title" value={institution.reserve_login_title} defaultValue={institution.reserve_login_title} onChange={(e) => setInstitution({...institution, reserve_login_title: e.target.value})}/>
         </div>
       </div>
  
       <div className="form-group">
         <label htmlFor="m_institution_gcs_institution_code">オンライン資格確認</label>
         <br />
         <div className="radio-inline">
          { requiredKbns.map((requiredKbn) =>{
             return(
               <>
                 <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={requiredKbn.value === institution.is_onshikaku} type="radio" value={`${requiredKbn.value}`} name="m_institution_is_onshikaku" id={`m_institution_is_onshikaku_${requiredKbn.value}`} onChange={changeIsOnshikaku}/>
                 <label className="m10" htmlFor={`m_institution_is_onshikaku_${requiredKbn.value}`}>{requiredKbn.label}</label>
               </>
           )})}
         </div>
         <br/>
         <div className="radio-inline w100p">
           <label htmlFor="m_institution_mi_code">ハッシュ化された医療機関コード</label>
           <input disabled={(!institution.is_onshikaku || !props.current_m_user.gcs_and_institution_editor_and_above)} className="form-control" placeholder="ハッシュ化された医療機関コード" type="text" id="m_institution_mi_code" value={institution.mi_code} defaultValue={institution.mi_code} onChange={(e) => setInstitution({...institution, mi_code: e.target.value})}/>
         </div>
       </div>
       </>
      )
      }

      { institution.interview_enable_flg == 1 && (
        <>
          <div className="form-group">
            <label>先確認設定</label>
            <br/>
            <div className="radio-inline w100p">
              <label htmlFor="m_institution_line_add_button">LINE友だち追加ボタン設定（※先確認サービス利用時のみ）</label>
              <textarea disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" rows={3} placeholder="LINE友だち追加ボタンのタグを貼り付けてください" id="m_institution_line_add_button" value={institution.line_add_button}  defaultValue={institution.line_add_button} onChange={(e) => setInstitution({...institution, line_add_button: e.target.value})}/>
            </div>
            <br/>
            <div className="radio-inline w100p">
              <label htmlFor="m_institution_line_add_qr">LINE友だち追加QRコード設定（※先確認サービス利用時のみ）</label>
              <textarea disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className="form-control" rows={3} placeholder="LINE友だち追加QRコードのタグを貼り付けてください" id="m_institution_line_add_qr" value={institution.line_add_qr}  defaultValue={institution.line_add_qr} onChange={(e) => setInstitution({...institution, line_add_qr: e.target.value})}/>
            </div>
            <br/>
            <div className="radio-inline">
              <label htmlFor="m_institution_line_add_qr">共通QRコード</label>
                { requiredKbns.map((requiredKbn) =>{
                  return(
                    <>
                      <input disabled={!props.current_m_user.gcs_and_institution_editor_and_above} className={ props.current_m_user.gcs_and_institution_editor_and_above ? "radio-input" : "radio-input-disabled"}  checked={requiredKbn.value === institution.is_interview_unification} type="radio" value={`${requiredKbn.value}`} name="m_institution_is_interview_unification" id={`m_institution_is_interview_unification_${requiredKbn.value}`} onChange={changeIsInterviewUnification}/>
                      <label className="m10" htmlFor={`m_institution_is_interview_unification_${requiredKbn.value}`}>{requiredKbn.label}</label>
                    </>
                  )})}
            </div>
            <br/>
            <div className="radio-inline w100p">
              <label htmlFor="m_institution_interview_message">一言メッセージ</label>
              <textarea disabled={(!institution.is_interview_unification || !props.current_m_user.gcs_and_institution_editor_and_above)} className="form-control" rows={3} placeholder="アンケートを選択してください" id="m_institution_interview_message" value={institution.interview_message}  defaultValue={institution.interview_message} onChange={(e) => setInstitution({...institution, interview_message: e.target.value})}/>
            </div>
          </div>
        </>
      )}
      

      {/* ボタン類 */}
      <div>
        <div className="actions mt40">
          <a className="btn btn-primary pull-left m5" href={`/${props.current_m_user.m_institution_key}/mypage/index`}>戻る</a> 
          <a className="btn btn-primary pull-right m5" type="hidden" data-toggle="modal" data-target="#user_form_modal">
            { props.action_name == "edit" ? ("更新する") : ("登録する") }
          </a>
        </div>
      </div>

      {/* 登録・更新確認 */}
      <div className="modal fade" data-backdrop="static" id="user_form_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>{ props.action_name == "edit" ? ("更新する") : ("登録する") }</h2>
          
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
            { props.action_name == "edit" ? ("この内容で更新します") : ("この内容で登録します") }
            <br />
            よろしいですか？<br />
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={() => submitInstitution() }
          >
          {props.action_name == "edit" ? ("更新する") : ("登録する") }
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>
    </LoadingOverlay>
    )
}
export default Index;